<template>
  <div
    style="
      height: 500px;
      overflow-x: hidden;
      overflow-y: scroll;
      margin-bottom: 30px;
      border: 1px solid #ccc;
      position: relative;
    "
  >
    <div id="loadingMessage" v-if="loadingMessage">
      <v-progress-circular :size="50" color="primary" indeterminate>
        Loading...
      </v-progress-circular
      >
    </div>
    <div class="d-flex align-center">
      <v-chip class="ma-2" color="pink" label text-color="white">
        <v-icon left> mdi-label</v-icon>
        {{ pdfName }}
      </v-chip>
      <v-chip
        color="primary"
        @click="downloadPDF"
        class="ma-2"
        label
        text-color="white"
      >
        <v-icon left> mdi-download</v-icon>
        Download
      </v-chip>
    </div>
    <VuePdfEmbed :source="pdfFile"/>
  </div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import {saveAs} from 'file-saver';

export default {
  props: {
    pdfFile: {
      type: String,
    },
    pdfName: {
      type: String,
    },
  },
  components: {
    VuePdfEmbed
  },
  data() {
    return {
      pdfSource: null,
      numPages: 0,
      loadingMessage: false,
    };
  },
  watch: {
    pdfFile: {
      handler(newPdfFile) {
        if (newPdfFile) {
          console.log({newPdfFile});
        }
      },
      immediate: true, // This makes the watcher run on component creation
    },
  },
  methods: {
    async downloadPDF() {
      try {
        this.loadingMessage = true;
        const response = await fetch(this.pdfFile);
        const blob = await response.blob();
        saveAs(blob, this.pdfName || "document.pdf");
      } catch (error) {
        console.error("Error downloading PDF:", error);
      } finally {
        this.loadingMessage = false;
      }
    },
  },
};
</script>

<style>
#loadingMessage {
  width: 96%;
  height: 80%;
  z-index: 1000;
  background: transparent;
  top: 70px;
  left: 35px;
  position: absolute;
}

#loadingMessage > div {
  left: 50%;
  top: 50%;
}
</style>
